import { useEffect, useState } from 'react';
import packageJson from '../../package.json';
import { authService } from '../services/authService';

const DebugPanel = () => {
  const [metaVersion, setMetaVersion] = useState(null);
  const [hasChecked, setHasChecked] = useState(false);
  const [isLatest, setIsLatest] = useState(true);
  const [lastCheckTime, setLastCheckTime] = useState(new Date());

  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Add cache-busting query parameter
        const timestamp = new Date().getTime();
        const response = await fetch(`/meta.json?t=${timestamp}`, {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setMetaVersion(data.version);
        setLastCheckTime(new Date());
        
        const currentVersion = packageJson.version;
        
        // Log current state
        // console.log('Version Check:', {
        //   running: currentVersion,
        //   meta: data.version,
        //   timestamp: new Date().toISOString()
        // });

        // Only update if versions don't match and we haven't checked yet
        if (data.version !== currentVersion && !hasChecked) {
          setHasChecked(true);
        //   console.log('Version mismatch detected:', {
        //     current: currentVersion,
        //     new: data.version
        //   });

          // Clear cache and reload after a short delay
          setTimeout(async () => {
            try {
              if ('caches' in window) {
                await caches.keys().then(keys => 
                  Promise.all(keys.map(key => caches.delete(key)))
                );
              }
              //window.location.reload(true);
            } catch (error) {
              console.error('Error during reload:', error);
            }
          }, 1000);
        }

        setIsLatest(data.version === currentVersion);
      } catch (error) {
        console.error('Error checking version:', error);
      }
    };

    // Initial check
    checkVersion();

    // Set up interval for subsequent checks
    const interval = setInterval(checkVersion, 30000);
    return () => clearInterval(interval);
  }, [hasChecked]);

  // Only show for Super Admin
  if (!authService.isSuperAdmin()) {
    return null;
  }

  return (
    <div style={{ 
      background: '#000', 
      padding: '10px 10px',
      color: '#fff',
      borderTop: '1px solid #333',
      fontFamily: 'monospace',
      fontSize: '11px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 1000
    }}>
      <div style={{ display: 'flex', gap: '20px' }}>
        <div style={{color: '#00ff00'}}>v{packageJson.version}</div>
        <div style={{color: metaVersion === packageJson.version ? '#00ff00' : '#ff0000'}}>
          Meta: {metaVersion || 'Loading...'}
        </div>
        <div>Latest: {String(isLatest)}</div>
        <div>Checked: {String(hasChecked)}</div>
        <div style={{color: '#888'}}>
          Updated: {lastCheckTime.toLocaleTimeString()}
        </div>
      </div>
      <button 
        onClick={() => {
          if ('caches' in window) {
            caches.keys().then(keys => 
              Promise.all(keys.map(key => caches.delete(key)))
            ).then(() => window.location.reload(true));
          } else {
            window.location.reload(true);
          }
        }} 
        style={{
          padding: '2px 8px',
          background: '#333',
          color: '#fff',
          border: '1px solid #666',
          borderRadius: '3px',
          cursor: 'pointer',
          fontSize: '11px'
        }}
      >
        Reload
      </button>
    </div>
  );
};

const CacheBusterComponent = ({ children }) => {
  return (
    <>
      {children}
    </>
  );
};

export { DebugPanel };
export default CacheBusterComponent; 